import { useState } from "react";
import { Modal } from "react-bootstrap";
import { useLanguage } from "../../Translations/LenguageContext";
import { useParams } from "react-router-dom";
import { ImSphere } from "react-icons/im";
import { IoDocumentOutline } from "react-icons/io5";
import {
    MdLoop,
    MdOutlineStarBorder,
    MdPeopleOutline,
    MdStackedLineChart,
} from "react-icons/md";
import { PiHandbag } from "react-icons/pi";
import { TbTheater } from "react-icons/tb";
import { BiPlus } from "react-icons/bi";

import CustomSource from "./01Custom";
import WebsiteSource from "./02Website";
import DocumentsSource from "./03Documents";

const SourcesModal = ({
    account_id,
    show,
    handleClose,
    fetchRecords,
}) => {
    const { t } = useLanguage();
    const { org_id, context_id } = useParams();
    const [step, setStep] = useState("choice");
    const [selectedSource, setSelectedSource] = useState(null);

    const sourceChoices = [
        {
            id: "website",
            label: t.context.website,
            icon: <ImSphere />,
            component: WebsiteSource,
        },
        {
            id: "documents",
            label: t.context.documents,
            icon: <IoDocumentOutline />,
            component: DocumentsSource,
        },
        // {
        //     id: "brand",
        //     label: "Brand",
        //     icon: <MdOutlineStarBorder />,
        //     component: null,
        // },
        // {
        //     id: "product",
        //     label: "Product",
        //     icon: <PiHandbag />,
        //     component: null,
        // },
        // {
        //     id: "competitors",
        //     label: "Competitors",
        //     icon: <MdPeopleOutline />,
        //     component: null,
        // },
        // {
        //     id: "market",
        //     label: "Market",
        //     icon: <MdStackedLineChart />,
        //     component: null,
        // },
        // {
        //     id: "audience",
        //     label: "Audience",
        //     icon: <TbTheater />,
        //     component: null,
        // },
        // {
        //     id: "feedback",
        //     label: "Feedback",
        //     icon: <MdLoop />,
        //     component: null,
        // },
        {
            id: "custom",
            label: t.context.custom,
            icon: <BiPlus />,
            component: CustomSource,
        },
    ];

    const closeModal = () => {
        handleClose();
        setStep("choice");
        setSelectedSource(null);
    };

    const handleSourceSelect = (source) => {
        setSelectedSource(source.id);
        setStep("source");
    };

    const handleBack = () => {
        setSelectedSource(null);
        setStep("choice");
    };

    const selectedSourceConfig = sourceChoices.find(
        (source) => source.id === selectedSource
    );

    const SourceComponent = selectedSourceConfig?.component;

    return (
        <Modal
            show={show}
            centered
            onHide={closeModal}
        >
            <div className="modal_header">
                <div className="modal_header_left">
                    <p className="modal_header_title">
                        {step != "choice" && <button className="modal_header_title_btn" onClick={handleBack}><i className="fa-solid fa-chevron-left"></i></button>}

                        {step === "choice"
                            ? t.context.new_source
                            : selectedSourceConfig?.label || t.context.new_source}
                    </p>
                </div>
            </div>

            {step === "choice" && (
                <div className="modal_main_cont">
                    <div className="source_choise_cont">
                        {sourceChoices.map((source) => (
                            <div
                                key={source.id}
                                className="source_choise fade-in"
                                onClick={() =>
                                    handleSourceSelect(source)
                                }
                            >
                                <i>
                                    {source.icon}
                                </i>

                                <p>
                                    {source.label}
                                </p>
                            </div>
                        ))}

                    </div>
                </div>
            )}

            {step === "source" && (
                <>
                    {SourceComponent ? (
                        <SourceComponent
                            account_id={account_id}
                            org_id={org_id}
                            context_id={context_id}
                            fetchRecords={fetchRecords}
                            closeModal={closeModal}
                            handleBack={handleBack}
                        />
                    ) : (
                        <div className="source_not_available">
                            <p>
                                {selectedSourceConfig?.label} {t.context.source_not_available}
                            </p>
                        </div>
                    )}
                </>
            )}

            {step === "choice" && (
                <div className="modal_footer">
                    <div></div>
                    <div className="modal_footer_btn_cont">
                        <button
                            type="button"
                            className="modale_close_btn"
                            onClick={closeModal}
                        >
                            {t.close}
                        </button>
                    </div>

                </div>
            )}
        </Modal>
    );
};

export default SourcesModal;